/* @flow */

export default {
  root: {
    width: 28,
    height: 25,

    fill: 'transparent !important',
  },
  'root-isFilled': {
    fill: 'inherit !important',
  },
  'root-large': {
    width: 33,
    height: 29,
  },
};
